import React from 'react';
import { CaretRightOutlined, ReloadOutlined, StopOutlined } from '@ant-design/icons';
import { isUnsetWorkDateTime } from 'src/utils/date/dateUtils';
import { formatDateWithTime } from 'src/utils/string/stringUtil';

const WORK_BUTTON_CLASS = "flex min-h-[52px] min-w-0 flex-1 items-center justify-center gap-[8px] rounded-[10px] bg-gradient-to-b from-[#2f67ec] to-[#1646b8] px-[10px] text-[17px] font-bold text-white shadow-md hover:brightness-105";
const RESET_BUTTON_CLASS = "flex min-h-[52px] min-w-0 flex-1 items-center justify-center gap-[8px] rounded-[10px] border border-[#ffbdc5] bg-gradient-to-b from-[#fff7f8] to-[#ffe8eb] px-[10px] text-[17px] font-bold text-[#d8324a] shadow-md hover:brightness-105";

interface KioskWorkTimeButtonFormProps {
  // 미등록(센티널) 일시이면 버튼 아래 시각을 표시하지 않는다.
  workStartDt: Date | string | null | undefined;
  workEndDt: Date | string | null | undefined;
  onWorkStartClick: () => void | Promise<unknown>;
  onWorkEndClick: () => void | Promise<unknown>;
  workStartTitle: string;
  workEndTitle: string;
  // 넘긴 경우에만 초기화 버튼을 표시한다.
  onResetClick?: () => void;
  resetTitle?: string;
  // 바깥 여백. 넘기면 기본값 전체를 대체한다.
  wrapperStyle?: string;
}

export const KioskWorkTimeButtonForm: React.FC<KioskWorkTimeButtonFormProps> = ({
  workStartDt,
  workEndDt,
  onWorkStartClick,
  onWorkEndClick,
  workStartTitle,
  workEndTitle,
  onResetClick,
  resetTitle,
  wrapperStyle = "mb-[10px]",
}) => {
  return (
    <div className={`${wrapperStyle} flex gap-[8px]`}>
      <button
        type="button"
        className={WORK_BUTTON_CLASS}
        onClick={() => void onWorkStartClick()}
      >
        <CaretRightOutlined />
        <span>
          {workStartTitle}
          {!isUnsetWorkDateTime(workStartDt) && (
            <small className="block text-[11px] font-medium">
              {formatDateWithTime(workStartDt || undefined)}
            </small>
          )}
        </span>
      </button>
      <button
        type="button"
        className={WORK_BUTTON_CLASS}
        onClick={() => void onWorkEndClick()}
      >
        <StopOutlined />
        <span>
          {workEndTitle}
          {!isUnsetWorkDateTime(workEndDt) && (
            <small className="block text-[11px] font-medium">
              {formatDateWithTime(workEndDt || undefined)}
            </small>
          )}
        </span>
      </button>
      {onResetClick && (
        <button
          type="button"
          className={RESET_BUTTON_CLASS}
          onClick={onResetClick}
        >
          <ReloadOutlined />
          {resetTitle}
        </button>
      )}
    </div>
  );
};
